module.exports = __webpack_public_path__ + "img/FileAudio.463a8b5c.svg";